import React from 'react'
import styled from 'styled-components'

const InputStyles = styled.input`
  border: 1px solid #dddddd;
  background-color: #fbfbfb;
  display: flex;
  color: #000;
  font-family: 'Open Sans';
  font-size: 14px;
  line-height: 19px;
  padding: 10px;
`

const Input = props => {
  const { type, name, placeholder, onChange } = props
  return (
    <InputStyles
      placeholder={placeholder}
      id={name}
      name={name}
      type={type}
      onChange={onChange}
    />
  )
}

export default Input
